import Form from '../multi-step-form'
import { useState } from 'react'
import Modal from '../../elements/modal'

const Calculator = ({ calculator, submit, modalContent }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const toggleModal = () => setModalOpen(!modalOpen)
  const handleKeypress = ({ key }) => key === 'Enter' && toggleModal()

  const calculatorSubmit = data => {
    const updateTerm = data => data.term && (data.term = data.term * 12)
    updateTerm(data)

    const calculatorData = {
      type: 'calculator',
      inputs: { ...data },
    }
    submit(calculatorData)
  }

  return (
    <div
      sx={{
        marginY: 0,
        padding: 'md',
        paddingTop: [24, 64],
        backgroundColor: 'grey-05',
        borderRadius: 3,
        variant: 'elements.calculator.container',
      }}
    >
      <div sx={{ variant: 'elements.calculator.wrapper' }}>
        <div sx={{ variant: 'elements.calculator.label' }}>{calculator.label}</div>
        <Form formType='calculator' schema={calculator} submit={calculatorSubmit} />

        <If condition={modalContent}>
          <div
            sx={{ variant: 'elements.calculator.modal.label' }}
            onClick={toggleModal}
            onKeyPress={handleKeypress}
            role='link'
            tabIndex={0}
          >
            How it works
            <Modal close={toggleModal} isOpen={modalOpen} type='calculator'>
              <div
                sx={{
                  flexDirection: ['column', 'row'],
                  variant: 'elements.calculator.modal.content',
                }}
              >
                {modalContent}
              </div>
            </Modal>
          </div>
        </If>
      </div>
    </div>
  )
}

export default Calculator
